var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavesMin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1349,
    height: 229,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-21.65 68.003c21.663 2.709 56.834 22.375 103.983 13 47.15-9.375 71.361-60.083 122.334-58 50.972 2.084 71.361 65.5 122.333 68 50.972 2.5 71.361-55.375 122.333-56 50.973-.625 71.361 47.792 122.334 53 50.972 5.209 71.361-31.75 122.333-28 50.972 3.75 71.361 45.375 122.333 46 50.973.625 71.361-39.25 122.334-43 50.972-3.75 71.363 25.625 122.333 25s71.36-33 122.33-28c50.98 5 75.19 50.334 122.34 52 47.15 1.667 82.32-34.833 103.98-44",
    stroke: "url(#a)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.65 243.003c21.663 2.709 56.834 22.375 103.983 13 47.15-9.375 71.361-60.083 122.334-58 50.972 2.084 71.361 65.5 122.333 68 50.972 2.5 71.361-55.375 122.333-56 50.973-.625 71.361 47.792 122.334 53 50.972 5.209 71.361-31.75 122.333-28 50.972 3.75 71.361 45.375 122.333 46 50.973.625 71.361-39.25 122.334-43 50.972-3.75 71.363 25.625 122.333 25s71.36-33 122.33-28c50.98 5 75.19 50.334 122.34 52 47.15 1.667 82.32-34.833 103.98-44",
    stroke: "url(#b)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.65 208.003c21.663 2.709 56.834 22.375 103.983 13 47.15-9.375 71.361-60.083 122.334-58 50.972 2.084 71.361 65.5 122.333 68 50.972 2.5 71.361-55.375 122.333-56 50.973-.625 71.361 47.792 122.334 53 50.972 5.209 71.361-31.75 122.333-28 50.972 3.75 71.361 45.375 122.333 46 50.973.625 71.361-39.25 122.334-43 50.972-3.75 71.363 25.625 122.333 25s71.36-33 122.33-28c50.98 5 75.19 50.334 122.34 52 47.15 1.667 82.32-34.833 103.98-44",
    stroke: "url(#c)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.65 173.003c21.663 2.709 56.834 22.375 103.983 13 47.15-9.375 71.361-60.083 122.334-58 50.972 2.084 71.361 65.5 122.333 68 50.972 2.5 71.361-55.375 122.333-56 50.973-.625 71.361 47.792 122.334 53 50.972 5.209 71.361-31.75 122.333-28 50.972 3.75 71.361 45.375 122.333 46 50.973.625 71.361-39.25 122.334-43 50.972-3.75 71.363 25.625 122.333 25s71.36-33 122.33-28c50.98 5 75.19 50.334 122.34 52 47.15 1.667 82.32-34.833 103.98-44",
    stroke: "url(#d)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.65 138.003c21.663 2.709 56.834 22.375 103.983 13 47.15-9.375 71.361-60.083 122.334-58 50.972 2.084 71.361 65.5 122.333 68 50.972 2.5 71.361-55.375 122.333-56 50.973-.625 71.361 47.792 122.334 53 50.972 5.209 71.361-31.75 122.333-28 50.972 3.75 71.361 45.375 122.333 46 50.973.625 71.361-39.25 122.334-43 50.972-3.75 71.363 25.625 122.333 25s71.36-33 122.33-28c50.98 5 75.19 50.334 122.34 52 47.15 1.667 82.32-34.833 103.98-44",
    stroke: "url(#e)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.65 103.003c21.663 2.709 56.834 22.375 103.983 13 47.15-9.375 71.361-60.083 122.334-58 50.972 2.084 71.361 65.5 122.333 68 50.972 2.5 71.361-55.375 122.333-56 50.973-.625 71.361 47.792 122.334 53 50.972 5.209 71.361-31.75 122.333-28 50.972 3.75 71.361 45.375 122.333 46 50.973.625 71.361-39.25 122.334-43 50.972-3.75 71.363 25.625 122.333 25s71.36-33 122.33-28c50.98 5 75.19 50.334 122.34 52 47.15 1.667 82.32-34.833 103.98-44",
    stroke: "url(#f)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -104.34,
    y1: -341.997,
    x2: 59.191,
    y2: -341.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -104.34,
    y1: -166.997,
    x2: 59.191,
    y2: -166.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -104.34,
    y1: -201.997,
    x2: 59.191,
    y2: -201.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -104.34,
    y1: -236.997,
    x2: 59.191,
    y2: -236.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -104.34,
    y1: -271.997,
    x2: 59.191,
    y2: -271.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -104.34,
    y1: -306.997,
    x2: 59.191,
    y2: -306.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB366"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesMin);
export default __webpack_public_path__ + "static/media/waves-min.bb1199610b4ef1812fd619bc19d11db3.svg";
export { ForwardRef as ReactComponent };